import { Modal, Typography } from 'antd'
import Button from 'components/button/Button'
import { JobBoardsVacanciesApplicationStatusEnum } from 'generated/api'
import { mapJobVacancyApplicantStatus } from 'helpers/wording'

interface IProps {
  isOpen: boolean
  nextApplicantStatus: JobBoardsVacanciesApplicationStatusEnum
  onCancel: () => void
  onConfirm: () => void
  fetchStatusUpdateJobApplicant: 'loading' | 'idle'
}

export default function ModalUpdateApplicantStatus(props: IProps) {
  const { isOpen, nextApplicantStatus, onCancel, onConfirm, fetchStatusUpdateJobApplicant } = props

  const loading = fetchStatusUpdateJobApplicant === 'loading'

  return (
    <Modal open={isOpen} footer={null} onCancel={onCancel} centered closeIcon={null}>
      <Typography.Paragraph className="text-center text-base text-[#333539] font-bold">
        Konfirmasi Perubahan Status Pelamar
      </Typography.Paragraph>
      <Typography.Paragraph className="text-center text-sm text-[#333539] font-normal">
        Anda akan mengubah status pelamar menjadi{' '}
        {mapJobVacancyApplicantStatus(nextApplicantStatus)}
      </Typography.Paragraph>
      <div className="flex gap-2">
        <Button
          disabled={loading}
          loading={loading}
          block={true}
          onClick={onCancel}
          data-testid="button_cancel"
          className="inline-block text-primary font-bold border border-primary"
          label="Batal"
        />
        <Button
          disabled={loading}
          loading={loading}
          block={true}
          onClick={onConfirm}
          data-testid="button_confirm"
          className="inline-block font-bold"
          iconPosition="right"
          label="Konfirmasi"
          variant="solid-primary"
        />
      </div>
    </Modal>
  )
}
